export enum CrossSaleAudienceType {
    RESIDENCE = "residence",
    BUSINESS = "business",
    BOTH = "both"
}

export enum CrossSaleCatalogType {
    CONTENT = "content",
    CART = "cart",
}

export enum CrossSaleType {
    PREDETERMINED = "predetermined",
    SHOPPING_CART = "shoppingCart",
}

export interface CrossSaleCatalogItem {
    name: string;
    logo: string;
    imageUrl: string;
    serviceTypeId: number;
    serviceId: number;
    productId: number;
}

export interface CrossSale {
    id: number;
    title: string;
    contentDisplayLimit: number;
    contentToDisplay: CrossSaleCatalogItem[];
    audience: CrossSaleAudienceType;
}

export interface CrossSaleGroup {
    title?: string;
    contentToDisplay: CrossSaleCatalogItem[];
}

export interface CrossSaleRequest {
    pageId: number;
    audience: CrossSaleAudienceType;
    cartId?: string;
}

export const CrossSalePageRoutes:  {[key: string]: number} = {
    'productsAndServices': 1,
};